import { create } from 'zustand';
import type { SpaceSettingsTab } from '../pages/Space/SpaceSettingsModal/SpaceSettingsModal';

/**
 * Lightweight request channel for opening the Space Settings modal at a specific
 * tab from anywhere in the space (e.g. the "Edit statuses" / "Manage labels"
 * actions in the task table dropdowns). The modal itself is owned by `Space.tsx`;
 * it watches `requestedTab` and opens on that tab, then calls `clearRequest`.
 */
interface SpaceSettingsStore {
  requestedTab: SpaceSettingsTab | null;
  requestOpen: (tab: SpaceSettingsTab) => void;
  clearRequest: () => void;
}

export const useSpaceSettingsStore = create<SpaceSettingsStore>((set) => ({
  requestedTab: null,
  requestOpen: (tab) => set({ requestedTab: tab }),
  clearRequest: () => set({ requestedTab: null }),
}));
